export default "/images/772bbe3c82bc760715161f1dff1a43e7.png";